import { useState, useEffect } from 'react';
import { produce } from 'immer';
import { useGetMeterReadsQuery } from '../../store/api-generated';
import divideArrayIntoParts from '../../helpers/divideArrayIntoParts';

const MAX_METER_READS_PER_PAGE = 10;

export default function usePaginatedMeterReads(id?: string) {
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setCurrentPage(1);
  }, [id]);

  const {
    data: meterReads = [],
    isLoading,
    isError,
  } = useGetMeterReadsQuery({
    contractId: id!,
  }, {
    skip: !id,
  });

  const sortedMeterReads = produce(meterReads, (draft) => {
    return draft.sort((a, b) => {
      return new Date(b.startDate!).getTime() - new Date(a.startDate!).getTime();
    });
  });

  const dividedMeterReads = divideArrayIntoParts(sortedMeterReads, MAX_METER_READS_PER_PAGE);

  const pagination = {
    totalPages: dividedMeterReads.length,
    totalInvoices: sortedMeterReads.length,
    currentPage,
    setCurrentPage,
  };

  return {
    meterReads: dividedMeterReads?.[currentPage - 1] || [],
    pagination,
    isLoading,
    isError,
  };
}
